function normalizeTag(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return null;

    // 중복 원소 제거
    const values = [
        ...new Set(
            arr
                .map(
                    (v) =>
                        String(v)
                            .trim() // 앞뒤 공백 제거
                            .replace(/\s+/g, '_'), // 중간 공백 → _
                )
                .filter(Boolean),
        ),
    ];

    if (values.length === 0) return null;

    // 원소가 배열이면 ','로 합치고, 아니면 그대로 반환
    // 모든 원소 사이를 '_'로 연결
    return values
        .map((value) => {
            return Array.isArray(value) ? value.join(',') : value;
        })
        .join('_');
}

const TAG_QUERY_ESCAPE_REGEX = /[\\,.<>{}\[\]"':;!@#$%^&*()\-+=~|\s]/g;

function escapeTagValue(value) {
    if (value === null || value === undefined) return value;
    return String(value).replace(TAG_QUERY_ESCAPE_REGEX, '\\$&');
}

function normalizeNumeric(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return null;

    // 첫 번째 값만 사용 (단일 numeric 필터용)
    const m = String(arr[0]).match(/-?\d+(\.\d+)?/);
    if (!m) return null;

    const n = Number(m[0]);
    return Number.isFinite(n) ? n : null;
}

function normalizeNumericRange(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return null;

    const nums = arr
        .map((v) => {
            const m = String(v).match(/-?\d+(\.\d+)?/);
            return m ? Number(m[0]) : null;
        })
        .filter((v) => Number.isFinite(v));

    if (nums.length === 0) return null;

    // 단일 값이면 [x x], 여러 개면 min/max
    const min = Math.min(...nums);
    const max = Math.max(...nums);

    return [min, max];
}

export { normalizeTag, escapeTagValue, normalizeNumeric, normalizeNumericRange };
